module.exports = __webpack_public_path__ + "static/media/empty-reports-img.0dc2047b.svg";